var render = function (_h,_vm) {var _c=_vm._c;return _c('FontAwesomeIcon',{staticClass:"animation-spin transition-transform",class:_vm.data.staticClass,attrs:{"icon":['fal', 'spinner-third']}})}
var staticRenderFns = []

export { render, staticRenderFns }